export const namespaced = true;

export const state = {
    fonts: [],
    loading: false,
}

export const mutations = {
    FETCH_FONTS(state, fonts) {
        state.fonts = fonts;
    },
}

export const actions = {

    async fetch({ commit, dispatch }) {
        try {
            const res = await axios.get(`/api/admin/fonts`);
            commit('FETCH_FONTS', res.data);
            return res.data;
        } catch (error) {
            const notification = {
                page: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },

    async delete({ dispatch }, fontId) {
        try {
            await axios.delete(`/api/admin/fonts/${fontId}`);
            dispatch('fetch');
        } catch (e) {
            throw e;
        }
    },

}
